import { createAsyncThunk } from '@reduxjs/toolkit';
import { postAlarmNote, getAlarmNotes, getAlarmRecordingUrl } from "../../services/api";
import { updateAlarmNotes } from './alarmSlice';

export const getAlarmNotesAsync: any | null = createAsyncThunk(
  'alarms/getAlarmNotes',
  async (data: any) => {
    const response = await getAlarmNotes(data);
    return response;
  },
);

export const postAlarmNoteAsync: any | null = createAsyncThunk(
  'alarms/postAlarmNote',
  async (data: any, { getState, dispatch }) => {
    const state: any = getState();
    const response = await postAlarmNote(data.newNote);
    if (response?.data.success) {
      // No refrescamos el listado de eventos aquí: getEventsAsync reescribe
      // dashboard.session, lo que dispara el resetPatientData del contenedor
      // Activity y cerraba el modal de resolución al añadir una nota. El refresco
      // se hace al cerrar el modal (NewResolutionsComponent).
      dispatch(updateAlarmNotes({
        ...data,
        applicantName: state.common.user.access,
      }));
    }
    return response;
  },
);

export const getAlarmRecordingUrlAsync: any | null = createAsyncThunk(
  'alarms/getAlarmRecordingUrl',
  async (data: any) => {
    const response = await getAlarmRecordingUrl(data);
    return response;
  },
);
